import ConfirmModal from '@/components/ConfirmModal';
import { cancelBookingLoadingSelector } from '@/features/loading/loadingSelectors';
import { useCancelInProgressPurchase } from '@/hooks/useCancelInProgressPurchase';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons, Typography } from '@packages/webshop-design-system';
import { type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

const CancelPurchaseButton: FC = () => {
  const { cancelPurchaseBooking } = useCancelInProgressPurchase();
  const isCancellingBooking = useSelector(cancelBookingLoadingSelector);
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <ConfirmModal
      title={<TransText i18nKey="cancelPurchase" />}
      description={
        <Typography variant="paragraph">
          <TransText i18nKey="areYouSureYouWantToCancelThePurchase" />
        </Typography>
      }
      cancelLabel="dismiss"
      confirmLabel="confirm"
      onConfirm={cancelPurchaseBooking}
      isConfirmLoading={isCancellingBooking}
    >
      <Button
        size={isLaptopOrBigger ? 'medium' : 'large'}
        data-testid="cancel-purchase-button"
        className="rounded-lg laptop:w-auto"
        variant="tertiary"
        startAdornment={<Icons.cancel />}
      >
        {/*TODO: Minor improvement idea - keep button size static */}
        <TransText i18nKey="cancel" />
      </Button>
    </ConfirmModal>
  );
};

export default CancelPurchaseButton;
